import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import { SabreLogo } from './SabreLogo';

/** Header, navigation and sign-out for every signed-in page. */
export function WorkspaceShell() {
  const { user, pcc, signOut } = useAuth();
  const navigate = useNavigate();

  const canManageUsers = user?.role === 'root' || user?.role === 'admin';

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true, state: { loggedOut: true } });
  };

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `workspace__nav-link${isActive ? ' workspace__nav-link--active' : ''}`;

  return (
    <div className="workspace">
      <header className="workspace__header">
        <NavLink to="/" className="workspace__brand">
          <SabreLogo width={92} />
          <span className="workspace__brand-divider" />
          <span className="workspace__brand-title">Agency Workspace</span>
        </NavLink>

        <nav className="workspace__nav">
          <NavLink to="/" className={navClass} end>
            Workspace
          </NavLink>
          <NavLink to="/overview" className={navClass}>
            Overview
          </NavLink>
          <NavLink to="/pnrs" className={navClass}>
            PNRs
          </NavLink>
          {canManageUsers && (
            <NavLink to="/admin/users" className={navClass}>
              Users
            </NavLink>
          )}
          {canManageUsers && (
            <NavLink to="/admin/reference" className={navClass}>
              Reference data
            </NavLink>
          )}
          {canManageUsers && (
            <NavLink to="/admin/agencies" className={navClass}>
              Agencies
            </NavLink>
          )}
          {canManageUsers && (
            <NavLink to="/admin/features" className={navClass}>
              Features
            </NavLink>
          )}
          {user?.role === 'root' && (
            <NavLink to="/admin/audit" className={navClass}>
              Activity
            </NavLink>
          )}
          <NavLink to="/security" className={navClass}>
            Security
          </NavLink>
        </nav>

        <div className="workspace__session">
          {pcc && <span className="workspace__pcc">PCC {pcc}</span>}
          <span>
            {user?.firstName || user?.lastName ? `${user.firstName} ${user.lastName}`.trim() : user?.userId}
          </span>
          <button type="button" className="workspace__signout" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </header>

      <main className="workspace__main">
        <Outlet />
      </main>
    </div>
  );
}
